import {
    CompanyUserManageVo,
    CoCompanyUser,
    AuthQuerySubAccountListUsingGetParams,
    QuerySubAccountByUidUsingGetParams,
    UserModularParam,
    AdapterQueryUserModularUsingGetParams,
    QueryBindUsingGetParams,
    ModularAuthorityVo,
    ErpBindParam
} from '@servicesTypings/companyRequest'
import { ListSubAccountUsingGetParams, UserPhoneVo } from '@servicesTypings/drpRequest'
import { companyRequest, timeOutTimer, drpRequest } from '@/utils/request'
import type { IPermissionPointData } from '@/services/types/getSimpleQueryUserModular'

/**
 * 添加子账号
 */
export function createAccount(data: CompanyUserManageVo): API.Res<CoCompanyUser> {
    return companyRequest.post('/subAccount/addSubAccount', { data })
}

/**
 * 编辑子账号
 */
export function updateAccount(data: CompanyUserManageVo): API.Res<CoCompanyUser> {
    return companyRequest.post('/subAccount/updateSubAccount', { data })
}

/**
 * 查询子账户列表(鉴权)
 */
export function queryAuthAccount(params: AuthQuerySubAccountListUsingGetParams): API.Res<CompanyUserManageVo[]> {
    return companyRequest.get('/subAccount/auth/querySubAccountList', { params })
}

/**
 * 获取配置了手机号的所有子账号
 */
export function listSubAccount(params: ListSubAccountUsingGetParams): API.Res<UserPhoneVo[]> {
    return drpRequest.get('/user/listSubAccount', { params })
}

/**
 * 根据uid查询子账号信息
 */
export function querySubAccountByUid(params: QuerySubAccountByUidUsingGetParams): API.Res<CoCompanyUser> {
    return companyRequest.get('/subAccount/querySubAccountByUid', { params })
}

/**
 * 查询当前公司的管理员名称列表
 */
export function getAdminUserNameList(): API.Res<object> {
    return drpRequest.get('/subAccount/getAdminUserNameList')
}

/**
 * 当前用户信息
 */
export function queryCurrentUserInfo(): API.Res<CompanyUserManageVo> {
    return companyRequest.get('/subAccount/currentUserInfo')
}

// 更新页面操作的权限点
/**
 * 修改模块详细自定义权限
 */
export function updateModularCustomAuthority(data: UserModularParam): API.Res<object> {
    return companyRequest.post('/company/permission/updateUserModular', { data })
}

export function getSimpleQueryUserModular(): API.Res<IPermissionPointData> {
    return companyRequest.get('/company/permission/simpleQueryUserModular', { timeout: timeOutTimer })
}

// 获取页面操作的权限点
/**
 * 获取模块详细自定义权限(适配)
 */
export function getModularCustomAuthority(
    params: AdapterQueryUserModularUsingGetParams
): API.Res<Record<string, object>> {
    return companyRequest.get('/company/permission/adapterQueryUserModular', { params })
}

// 检查用户是否初始化密码
/**
 * 是否设置密码
 */
export function hasSetPwd(): API.Res<object> {
    return drpRequest.get('/subAccount/hasSetPwd')
}

// 查询绑定权限:店铺和分销商
/**
 * 查询绑定权限:店铺和分销商
 */
export function queryBindShopAndChannel(params: QueryBindUsingGetParams): API.Res<ModularAuthorityVo> {
    return companyRequest.get('/erp/data/permission/queryBind', { params })
}

// 更新绑定权限:店铺和分销商
/**
 * 更新绑定权限:店铺和分销商
 */
export function updateBindShopAndChannel(data: ErpBindParam): API.Res<null> {
    return companyRequest.post('/erp/data/permission/updateBind', { data })
}
